/* ===========================================================================
   c-lp-anchor.js — keep the URL hash on in-page LP anchors (Step Labs)
   ===========================================================================

   Progressive enhancement only. A c-lp-* CTA such as "See The One We
   Recommend" is a plain `<a href="#recommended">`, so without JavaScript the
   browser jumps to the section and updates the hash natively (c-global.css
   adds `scroll-margin-top` and smooth scroll).

   With the theme's JavaScript alive, main.js (`internalLinksSmoothScroll`,
   theme setting) cancels that click and scrolls with its sticky-header offset,
   which leaves the hash untouched: the link cannot be shared or restored with
   Back. This listener lets the theme scroll as it wants and, only when the
   click was cancelled, writes the hash with `history.pushState` (no second
   scroll, no `hashchange` jump).

   Delegated on `document` for links inside any `[data-sl-id^="c-lp-"]` root,
   so sections re-rendered by the editor (`shopify:section:load`) are covered
   without re-binding; the guard stops a second copy of the file binding twice.

   Load from a section with:
     <script src="{{ 'c-lp-anchor.js' | asset_url }}" defer></script>
   =========================================================================== */
(function () {
  if (window.__cLpAnchorBound) return;
  window.__cLpAnchorBound = true;

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('[data-sl-id^="c-lp-"] a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (hash.length < 2) return;

    var target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return;
    }
    if (!target) return;

    // Runs after every other click listener (the theme's included).
    setTimeout(function () {
      if (event.defaultPrevented && window.location.hash !== hash) {
        window.history.pushState(null, '', hash);
      }
    }, 0);
  });
})();
